import * as input from './inputStyles';
import * as surface from './surfaceStyles';
import * as dataDisplay from './dataDisplayStyles';
import * as feedback from './feedbackStyles';
const globalStyles = (theme) => ({
  ...surface.appBarStyles(theme),
  ...input.formStyles(theme),
  ...input.buttonStyles(theme),
  ...dataDisplay.tableStyles(theme),
  ...feedback.backdropStyles(theme),
});

export default globalStyles;
